import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api, formatRupiah } from "../lib/api";
import { useCart } from "../contexts/CartContext";
import { ShoppingBag, ArrowLeft, Check } from "lucide-react";
import { toast } from "sonner";

export default function ProductDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { addItem } = useCart();
  const [p, setP] = useState(null);
  useEffect(() => {
    api.get(`/products/${slug}`).then(r => setP(r.data)).catch(() => navigate("/products"));
  }, [slug, navigate]);
  if (!p) return <div className="lumina-container py-20 text-center text-[#5C5870]">Memuat…</div>;
  const addToCart = () => {
    addItem({ item_type: "product", item_id: p.id, title: p.title, price: p.price, image: p.image });
    toast.success("Ditambahkan ke keranjang");
  };
  const buyNow = () => { addToCart(); navigate("/checkout"); };

  return (
    <div className="lumina-container py-12" data-testid="product-detail-page">
      <Link to="/products" className="inline-flex items-center gap-2 text-[#5C5870] hover:text-[#6B4BA3] mb-8 text-sm"><ArrowLeft className="w-4 h-4" /> Kembali ke produk</Link>
      <div className="grid lg:grid-cols-2 gap-12">
        <div className="lumina-card overflow-hidden">
          <img src={p.image} alt={p.title} className="w-full aspect-square object-cover" />
        </div>
        <div>
          <span className="lumina-label">{p.category.replace("_", " ")}</span>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-[#1A1728] mt-3 mb-5 leading-tight">{p.title}</h1>
          <div className="flex items-baseline gap-3 mb-6">
            <span className="text-[#6B4BA3] font-semibold text-3xl">{formatRupiah(p.price)}</span>
            {p.original_price && p.original_price > p.price && <span className="text-[#5C5870] line-through">{formatRupiah(p.original_price)}</span>}
          </div>
          <p className="text-[#5C5870] leading-relaxed mb-8 text-lg">{p.long_description || p.description}</p>
          <div className="space-y-3 mb-8">
            {["File digital instan setelah pembayaran", "Cocok untuk GoodNotes, Notability, atau cetak", "Akses seumur hidup"].map(b => (
              <div key={b} className="flex items-center gap-3"><Check className="w-5 h-5 text-[#6B4BA3]" /> <span className="text-[#1A1728]">{b}</span></div>
            ))}
          </div>
          <div className="flex flex-wrap gap-3">
            <button onClick={buyNow} className="lumina-btn-primary" data-testid="buy-now-btn"><ShoppingBag className="w-4 h-4" /> Beli Sekarang</button>
            <button onClick={addToCart} className="lumina-btn-outline" data-testid="add-cart-btn">+ Keranjang</button>
          </div>
        </div>
      </div>
    </div>
  );
}
